// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Vwxh","right":"Footer_right__1GMEw","buttons":"Footer_buttons__Nvny9"};